module.exports = __webpack_public_path__ + "img/LAMBORGHINI.35d1d49.jpg";